<template>
  <div class="menu-secondary">
    <div class="menu-secondary__main" v-if="!!$scopedSlots['item-structure']">
      <app-heading level="h6" class="menu-secondary__main__title">{{title}}</app-heading>
      <app-menu-local dark :items="items">
        <template v-slot:item-structure="{item}">
          <slot name="item-structure" v-bind:item="item"></slot>
        </template>
      </app-menu-local>
    </div>
    <div class="menu-secondary__actions">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script>
import Heading from '../Typography/Heading.vue'
import MenuLocal from './Local.vue'
export default {
  name: 'AppMenuSecondary',
  status: 'prototype',
  release: '1.0.0',
  components: { MenuLocal, Heading },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      menuIsOpen: false
    }
  },
  computed: {
    itemsList () {
      return this.items.map((item, index) => {
        item._uuid = index
        return item
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/styles.scss";
$padding-base: 15px;
.menu-secondary {
  @include reset();
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  padding: 22px;
  background-color: $color-purple-darker;
  font-family: $font-text;
  color: $color-ice;
  @media #{$media-query-l} {
    padding: 22px 70px;
  }
  &__main {
    @include reset();
    display: block;
    padding: 10px 0;
    overflow: hidden;
    list-style: none;
    transition: width 0.5s cubic-bezier(0.77, 0.2, 0.05, 1);
    @media #{$media-query-l} {
      padding: 0 $padding-base 0 0;
    }
    @media #{$media-query-m} {
      display: flex;
      flex-direction: column;
      flex-grow: 5;
      flex-direction: row;
      flex-wrap: wrap;
      height: auto;
    }
    &__title {
      font-weight: 600;
      color: $color-gray-light;
      margin-bottom: 10px;
    }
  }
  &__actions {
    display: flex;
    width: 100%;
    flex-direction: row;
    flex-grow: 5;
    justify-content: space-between;
    padding: 0;
    @media #{$media-query-m} {
      width: auto;
      padding-left: $padding-base;
      justify-content: flex-end;
    }
  }
}
</style>
